import { getAPIUrl } from '../helpers/App';

export const APIgetClients = params => (
  window.axios.get(getAPIUrl('/clients'), { params })
    .then(response => (response))
);

export const APIgetClient = clientUuid => (
  window.axios.get(getAPIUrl(`/clients/${clientUuid}`))
    .then(response => (response.data))
);

export const APIgetClientStats = clientUuid => (
  window.axios.get(getAPIUrl(`/clients/${clientUuid}/stats`))
    .then(response => (response.data))
);

export const APIupdateClient = (clientUuid, params) => (
  window.axios.patch(getAPIUrl(`/clients/${clientUuid}`), params)
    .then(response => (response.data))
);

export const APIdeleteClient = (clientUuid) => (
  window.axios.delete(getAPIUrl(`/clients/${clientUuid}`))
    .then(response => (response.data))
);

export const APIgetClientUsage = () => (
  window.axios.get(getAPIUrl('/client/usage'))
    .then(response => (response))
);

export const APIclientCreate = params => (
  window.axios.post(getAPIUrl('/signup'), params)
    .then(response => (response.data))
);
